import React from 'react';
import TextField from '@mui/material/TextField';

const TextArea = ({ className = '', rows = 4, autogrow = false, ...rest }) => {
	const textFieldProps = autogrow 
		? { minRows: rows, maxRows: Infinity }
		: { rows };
	
	return <div className={`nf-material-wrapper ${className}`}>
		<TextField multiline {...rest} {...textFieldProps} fullWidth />
	</div>;
};


TextArea.type = 'TextArea';
TextArea.spec = [{
	name: 'TextArea',
	key: 'TextArea',
	title: 'Long text field',
	icon: 'AlignJustify',
	category: 'input',
	translatable: ['label'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];

export default TextArea;